const getWorkOrderDueDateClassName = (slaEnd: Date): string => {
  let className = "due-date-ok";
  const utcInHours = new Date(Date.now()).getTime() / 3600000;
  const slaTimeInHours = slaEnd.getTime() / 3600000;

  if (slaTimeInHours - utcInHours <= 0) {
    className = "due-date-expired";
  } else if (slaTimeInHours - utcInHours <= 1) {
    className = "due-date-near";
  }

  return className;
};

export { getWorkOrderDueDateClassName };
